import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  type RouterHistory,
} from '@tanstack/react-router'
import type { FC } from 'react'
import { Kabuk } from './components/kabuk'
import { COZUMLER } from './icerik/cozumler'
import { MODULLER } from './icerik/moduller'
import { AnaSayfa } from './routes/ana-sayfa'
import { Bulunamadi } from './routes/bulunamadi'
import { Cozumler, CozumSayfasi } from './routes/cozumler'
import { Entegrasyonlar } from './routes/entegrasyonlar'
import { Fiyatlandirma } from './routes/fiyatlandirma'
import { Gecis } from './routes/gecis'
import { Hakkimizda } from './routes/hakkimizda'
import { Gizlilik, Kosullar, Kvkk } from './routes/hukuk'
import { Iletisim } from './routes/iletisim'
import { Karsilastirma } from './routes/karsilastirma'
import { Ozellikler, OzellikSayfasi } from './routes/ozellikler'
import { Sss } from './routes/sss'
import { YolHaritasi } from './routes/yol-haritasi'

/**
 * Sayfa kaydı: yol → bileşen. Hem rota ağacı hem ön-render listesi buradan
 * türer; ikisi ayrı tutulsaydı yeni sayfa sessizce ön-render dışında kalırdı.
 *
 * Modül ve çözüm sayfaları dinamik parametre yerine TEK TEK yol olarak
 * kaydedilir: ön-render için yolların derleme anında bilinmesi gerekiyor ve
 * içerik zaten koddaki katalogdan geliyor.
 */
const SAYFALAR: Array<{ path: string; component: FC }> = [
  { path: '/', component: AnaSayfa },
  { path: '/ozellikler', component: Ozellikler },
  ...MODULLER.map((m) => ({
    path: `/ozellikler/${m.slug}`,
    component: function ModulSayfasi() {
      return <OzellikSayfasi slug={m.slug} />
    },
  })),
  { path: '/cozumler', component: Cozumler },
  ...COZUMLER.map((c) => ({
    path: `/cozumler/${c.slug}`,
    component: function CozumRota() {
      return <CozumSayfasi slug={c.slug} />
    },
  })),
  { path: '/fiyatlandirma', component: Fiyatlandirma },
  { path: '/karsilastirma', component: Karsilastirma },
  { path: '/gecis', component: Gecis },
  { path: '/entegrasyonlar', component: Entegrasyonlar },
  { path: '/yol-haritasi', component: YolHaritasi },
  { path: '/sss', component: Sss },
  { path: '/hakkimizda', component: Hakkimizda },
  { path: '/iletisim', component: Iletisim },
  { path: '/kvkk', component: Kvkk },
  { path: '/gizlilik', component: Gizlilik },
  { path: '/kosullar', component: Kosullar },
]

const rootRoute = createRootRoute({
  component: () => (
    <Kabuk>
      <Outlet />
    </Kabuk>
  ),
  notFoundComponent: Bulunamadi,
})

const routes = SAYFALAR.map((s) =>
  createRoute({ getParentRoute: () => rootRoute, path: s.path, component: s.component }),
)

/** Ön-render edilecek yollar (scripts/prerender.mjs). */
export const YOLLAR: string[] = SAYFALAR.map((s) => s.path)

export function createAppRouter(history?: RouterHistory) {
  return createRouter({
    routeTree: rootRoute.addChildren(routes),
    history,
    // `scrollRestoration` KAPALI: açıkken router sunucuda bir <script>
    // basıyor (ScriptOnce), tarayıcıda basmıyor; ön-render edilmiş ağaçla
    // hydrate uyuşmuyordu. Sayfa değişiminde en üste kaydırmayı kabuk yapar,
    // yeniden yüklemede konumu tarayıcı kendisi geri getirir.
    defaultPreload: 'intent',
  })
}

/*
 * Router tip kaydı (`Register`) bilerek YOK: sayfalar katalogdan dinamik
 * üretildiği için tip düzeyinde yol listesi yok; kayıt yapılsaydı `Link`
 * yalnızca "/" kabul ederdi. Yollar dizge olarak geçer; kırık bağlantıyı
 * ön-render sonrası bağlantı denetimi yakalar (scripts/prerender.mjs).
 */
